<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" > External Contact </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--6">
  <form [formGroup]="accountForm" (ngSubmit)="onSubmit()">
    <div class=" row">
      <div class=" col-lg">
        <div class=" card-wrapper">
          <div class="card" >
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Contact Information</h3>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="p-2 mb-2">
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        First Name
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('firstName')?.invalid
                               && accountForm.get('firstName')?.touched }"
                               class="form-control"
                               formControlName="firstName" >
                        <div
                          *ngIf="accountForm.get('firstName')?.invalid     && accountForm.get('firstName')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('firstName')?.hasError('required')">
                            First name is required.
                          </div>
                          <div *ngIf="accountForm.get('firstName')?.hasError('maxlength')">
                            First name cannot
                            exceed {{ accountForm.get('firstName')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>

                      </div>

                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Last Name
                      </label>
                      <div class="col-md-9">
                        <input type="text" class="form-control"
                               [ngClass]="{ 'is-invalid': accountForm.get('lastName')?.invalid
                               && accountForm.get('lastName')?.touched }"
                               formControlName="lastName">
                        <div
                          *ngIf="accountForm.get('lastName')?.invalid     && accountForm.get('lastName')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('lastName')?.hasError('required')">
                            Last Name is required.
                          </div>
                          <div *ngIf="accountForm.get('lastName')?.hasError('maxlength')">
                            Last Name cannot
                            exceed {{ accountForm.get('lastName')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Position
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('position')?.invalid
                               && accountForm.get('position')?.touched }"
                               class="form-control"
                               formControlName="position">
                        <div
                          *ngIf="accountForm.get('position')?.invalid     && accountForm.get('position')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('position')?.hasError('required')">
                            Position is required.
                          </div>
                          <div *ngIf="accountForm.get('position')?.hasError('maxlength')">
                            Position cannot
                            exceed {{ accountForm.get('position')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Email
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('email')?.invalid
                               && accountForm.get('email')?.touched }"
                               class="form-control"
                               formControlName="email">
                        <div
                          *ngIf="accountForm.get('email')?.invalid     && accountForm.get('email')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('email')?.hasError('required')">
                            Email is required.
                          </div>
                          <div *ngIf="accountForm.get('email')?.hasError('maxlength')">
                            Email cannot
                            exceed {{ accountForm.get('email')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Phone
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('phone')?.invalid
                               && accountForm.get('phone')?.touched }"
                               class="form-control"
                               formControlName="phone">
                        <div
                          *ngIf="accountForm.get('phone')?.invalid     && accountForm.get('phone')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('phone')?.hasError('required')">
                            Phone is required.
                          </div>
                          <div *ngIf="accountForm.get('phone')?.hasError('maxlength')">
                            Phone cannot
                            exceed {{ accountForm.get('phone')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Preferred Channel
                      </label>
                      <div class="col-md-9">
                        <select formControlName="contactMethodId"
                                class="form-control">
                          <option *ngFor="let method of contactMethods" [value]="method.id">
                            {{ method.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="accountForm.get('contactMethodId')?.invalid     && accountForm.get('contactMethodId')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('contactMethodId')?.hasError('required')">
                            Preferred Method of Contact is required.
                          </div>
                          <div *ngIf="accountForm.get('contactMethodId')?.hasError('maxlength')">
                            Preferred Method of Contact cannot
                            exceed {{ accountForm.get('contactMethodId')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
                <div class="row">

                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Citizenship
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('citizenship')?.invalid
                               && accountForm.get('citizenship')?.touched }"
                               class="form-control"
                               formControlName="citizenship">
                        <div
                          *ngIf="accountForm.get('citizenship')?.invalid     && accountForm.get('citizenship')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('citizenship')?.hasError('required')">
                            Citizenship is required.
                          </div>
                          <div *ngIf="accountForm.get('citizenship')?.hasError('maxlength')">
                            Citizenship cannot
                            exceed {{ accountForm.get('citizenship')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Passport nr
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               class="form-control"
                               [ngClass]="{ 'is-invalid': accountForm.get('passport')?.invalid
                               && accountForm.get('passport')?.touched }"
                               formControlName="passport">
                        <div
                          *ngIf="accountForm.get('passport')?.invalid     && accountForm.get('passport')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('passport')?.hasError('required')">
                            Passport nr is required.
                          </div>
                          <div *ngIf="accountForm.get('passport')?.hasError('maxlength')">
                            Passport nr cannot
                            exceed {{ accountForm.get('passport')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>
                <div class="row">


                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Birthday
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('birthday')?.invalid
                               && accountForm.get('birthday')?.touched }"
                               formControlName="birthday"
                               [bsConfig]="{    rangeInputFormat: 'DD/MM/YYYY',    dateInputFormat: 'DD/MM/YYYY',    showWeekNumbers: false  }"
                               bsDatepicker
                               class="form-control"
                               placeholder="dd/mm/yyyy">
                        <div
                          *ngIf="accountForm.get('birthday')?.invalid     && accountForm.get('birthday')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('birthday')?.hasError('required')">
                            Birthday is required.
                          </div>
                          <div *ngIf="accountForm.get('birthday')?.hasError('maxlength')">
                            Birthday cannot
                            exceed {{ accountForm.get('birthday')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        Place of birth
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('placeOfBirth')?.invalid
                               && accountForm.get('placeOfBirth')?.touched }"
                               class="form-control"
                               formControlName="placeOfBirth">
                        <div
                          *ngIf="accountForm.get('placeOfBirth')?.invalid     && accountForm.get('placeOfBirth')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('placeOfBirth')?.hasError('required')">
                            Place of birth is required.
                          </div>
                          <div *ngIf="accountForm.get('placeOfBirth')?.hasError('maxlength')">
                            Place of birth cannot
                            exceed {{ accountForm.get('placeOfBirth')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group row">
                      <label class="col-md-3 col-form-label form-control-label">
                        POGO nr
                      </label>
                      <div class="col-md-9">
                        <input type="text"
                               [ngClass]="{ 'is-invalid': accountForm.get('pOgOnR')?.invalid
                               && accountForm.get('pOgOnR')?.touched }"
                               class="form-control"
                               formControlName="pOgOnR">
                        <div
                          *ngIf="accountForm.get('pOgOnR')?.invalid     && accountForm.get('pOgOnR')?.touched"
                          class="invalid-feedback">
                          <div *ngIf="accountForm.get('pOgOnR')?.hasError('required')">
                            POGO nr is required.
                          </div>
                          <div *ngIf="accountForm.get('pOgOnR')?.hasError('maxlength')">
                            POGO nr cannot
                            exceed {{ accountForm.get('pOgOnR')?.errors?.maxlength.requiredLength }}
                            characters.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card"          >
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  Payment Account
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row" >
                <div class="col-12">
                  <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                    <tr>
                      <th>Account Holder</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr  >
                      <td [attr.data-id]="paymentInfo?.id">{{ paymentInfo?.accountHolderName}}</td>
                    </tr>
                    </tbody>
                  </table>

                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addPaymentInfo()">Change Payment Account</button>
                  </div>
                </div>
              </div>
            </div>
          </div>





          <div class="card">
            <div class="card-body">
              <button class="btn btn-primary" type="submit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>



